import React from 'react';
export function TeamSection() {
  const team = [{
    name: 'Annysol Navarro',
    role: 'Directivo',
    image: 'https://cdn.magicpatterns.com/uploads/8NP2pHeGc6dbUz7zs3MLij/Annysol_Navarro.png'
  }, {
    name: 'Daniel Martin',
    role: 'Directivo',
    image: 'https://cdn.magicpatterns.com/uploads/6DRZfYDiTxxJKDxUCC7HVx/Daniel_Martin.jpg'
  }, {
    name: 'Sasha Escalante',
    role: 'Directivo',
    image: 'https://cdn.magicpatterns.com/uploads/7BGxJCNx8Rv31F3PD64r7H/Sasha_Escalante.jpg'
  }, {
    name: 'Ginette Camacho',
    role: 'Directivo',
    image: 'https://cdn.magicpatterns.com/uploads/6WsnZafBn3ktfHpJmkKspa/Ginette_Camacho.jpg'
  }, {
    name: 'Liudmila Guas',
    role: 'Directivo',
    image: 'https://cdn.magicpatterns.com/uploads/iTphiQ9bh6WaXS846vZEzm/Liudmila_Guas.png'
  }];
  return <section id="equipo" className="bg-white py-10 px-4 md:py-20 md:px-8" data-id="element-193" data-mp="vexfpzp0jc5t">
      <div className="max-w-5xl mx-auto" data-id="element-194" data-mp="1u67ndpafjc6c">
        <div className="text-center mb-10" data-id="element-195" data-mp="1u560mnk1x18s">
          <span className="block text-[14px] md:text-[18px]" style={{
          fontWeight: 600,
          color: '#7DC920',
          textTransform: 'uppercase',
          letterSpacing: '3px',
          marginBottom: '8px'
        }} data-id="element-196" data-mp="1z63h8vpexn86">
            Nuestro Equipo
          </span>
          <span className="block text-[24px] md:text-[38px]" style={{
          fontWeight: 700,
          color: '#1a1a1a'
        }} data-id="element-197" data-mp="2duzxhg1mi6jv">
            Personas que sostienen el cambio
          </span>
        </div>

        <div className="mp-team-grid grid grid-cols-2 gap-3 md:flex md:flex-wrap md:justify-center md:gap-6" data-id="element-198" data-mp="29383evj9dioz">
          {team.map((member, index) => {
          const isLastOdd = index === team.length - 1 && team.length % 2 === 1;
          return <div key={index} className={`${isLastOdd ? 'mp-team-card-last col-span-2 mx-auto max-w-[180px] md:max-w-none md:mx-0' : ''} md:basis-[calc(33.333%-16px)] bg-primary/5 rounded-xl md:rounded-2xl p-4 px-2 md:p-10 text-center shadow-md hover:shadow-xl hover:scale-[1.03] transition-all duration-300`} data-id="element-199" data-mp="31m5evzn7p6wa" data-mpi={index}>
                <div className="w-16 h-16 md:w-36 md:h-36 bg-gradient-to-br from-primary/20 to-accent/20 rounded-full mx-auto mb-3 md:mb-6 flex items-center justify-center overflow-hidden" data-id="element-200" data-mp="2whqpp1jmu2te">
                  {member.image ? <img src={member.image} alt={member.name} className="w-full h-full object-cover" data-id="element-201" data-mp="2np5jsm13nqlz" /> : <div className="text-[18px] md:text-4xl font-bold text-primary" data-id="element-202" data-mp="2dqfz6lhtjs21">
                      {member.name.split(' ').map(n => n[0]).join('')}
                    </div>}
                </div>
                <h3 className="text-[13px] md:text-xl font-semibold md:font-bold text-dark mb-1 md:mb-2" data-id="element-203" data-mp="kbwhdgg677f9">
                  {member.name}
                </h3>
                <p style={{
              fontSize: '13px',
              color: '#7DC920',
              fontWeight: 500
            }} data-id="element-204" data-mp="tbjkc6ojslaf">
                  {member.role}
                </p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}